<template>
  <button class="popover-checkmark-btn">
    <svg-icon width="16px" height="16px" :icon="Check"></svg-icon>
  </button>
</template>

<script>
import SvgIcon from '@/components/common/svgIcon'
import Check from '@/assets/svg/Check.svg'

export default {
  components: {
    SvgIcon
  },
  data () {
    return {
      Check
    }
  }
}
</script>

<style lang="scss">
.popover-checkmark-btn {
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #A0A7AC;
  color: black;
  font-size: 16px;
  z-index: $z-4;

  &:hover {
    background-color: #27A500;
    cursor: pointer;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;

    &:hover {
      background-color: #A0A7AC;
    }
  }
}
</style>




// WEBPACK FOOTER //
// PopoverCheckmarkBtn.vue?7e27b6fd